import { render, staticRenderFns } from "./TurnoverDisplay.vue?vue&type=template&id=40ee410a&scoped=true&"
import script from "./TurnoverDisplay.vue?vue&type=script&lang=js&"
export * from "./TurnoverDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TurnoverDisplay.vue?vue&type=style&index=0&id=40ee410a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ee410a",
  null
  
)

export default component.exports